import { render, staticRenderFns } from "./ToTopButton.vue?vue&type=template&id=52fc76ae&"
import script from "./ToTopButton.vue?vue&type=script&lang=js&"
export * from "./ToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./ToTopButton.vue?vue&type=style&index=0&id=52fc76ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports